import dynamic from "next/dynamic";

import animationData from "../../../public/lotties/equaliser.json";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

interface EqualiserProps {
  size?: number;
  className?: string;
}

export const Equaliser = ({ size = 24, className }: EqualiserProps) => {
  return (
    <div
      style={{
        width: size,
        height: size,
      }}
      className={className}
    >
      <Lottie
        loop
        autoplay
        height={size}
        width={size}
        animationData={animationData}
      />
    </div>
  );
};
